<template lang="pug">
div
  base-snackbar(
    :errors.sync="expenseCategoryGetErrors"
  )
  v-data-table(
    :items="expenseCategoryList"
    :headers="headers"
    dense
    :loading="expenseCategoryGetting"
  )
    template(v-slot:item="{ item }")
      tr
        td {{ item.description }}
        td
          base-tooltip(
            bottom
            color="yellow darken-3"
            text
            dark
            x-small
            tooltip="edit"
            @click="$emit('input', item)"
            v-if="authPermissions.has('expense_categories:edit')"
          )
            v-icon mdi-pencil
</template>
<script>
import VueRequestHandler from '@/classes/VueRequestHandler.class'
import requestVars from '@/extra-functions/request-vars.extra'
import expenseCategoryRepository from '@/repositories/expense-category.repository'
import { mapState } from 'vuex'

const [expenseCategoryGetVars, expenseCategoryGetVarNames] = requestVars({ identifier: 'expense-category' })
const expenseCategoryHandler = new VueRequestHandler(null, expenseCategoryGetVarNames)
const tableVars = () => ({
  headers: [{ text: 'Category', value: 'description' }, { text: 'Config', sortable: false }],
})
export default {
  name: 'TableExpenseCategory',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    ...tableVars(),
    ...expenseCategoryGetVars,
    websocketEvents: [],
  }),
  created() {
    this.fetchExpenseCategory()
    this.initWebsocketEvents()
  },
  beforeDestroy() {
    this.websocketEvents.forEach(eventId => {
      this.$store.dispatch('websocket/detachFromListener', [eventId])
    })
    this.websocketEvents = []
  },
  computed: {
    ...mapState({
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  methods: {
    fetchExpenseCategory() {
      const handler = expenseCategoryHandler
      const repository = expenseCategoryRepository.index
      handler.setVue(this)
      handler.execute(repository)
    },
    async initWebsocketEvents() {
      const dbStoreEventId = await this.$store.dispatch('websocket/attachToListener', ['DBStoreEvent', this.dbStoreEvent])
      const dbUpdateEventId = await this.$store.dispatch('websocket/attachToListener', ['DBUpdateEvent', this.dbUpdateEvent])
      this.websocketEvents.push(dbStoreEventId, dbUpdateEventId)
    },
    dbStoreEvent({ data, model }) {
      if (!model || this.$objectEmpty(data)) return
      if (model === 'ExpenseCategory') {
        this.expenseCategoryDBStoreEvent(data)
      }
    },
    dbUpdateEvent({ data, model }) {
      if (!model || this.$objectEmpty(data)) return
      if (model === 'ExpenseCategory') {
        this.expenseCategoryDBUpdateEvent(data)
      }
    },
    expenseCategoryDBUpdateEvent(data) {
      this.expenseCategoryList = this.expenseCategoryList.map(item => {
        if (Number(data.id) === Number(item.id)) {
          return Object.assign({ ...data })
        }
        return Object.assign({ ...item })
      })
    },
    expenseCategoryDBStoreEvent(data) {
      this.expenseCategoryList.push(data)
    },
  },
}
</script>
